import React, { useState } from "react";
import i18next from "i18next";
import { isValidEmail } from "../../../helpers/input";
import { FormFeedback, FormGroup, Input, Label } from "reactstrap";

const Email = (props) => {
  const [touched, setTouched] = useState(false);

  const showError =
    touched &&
    ((props.isRequired && !props.value) || !isValidEmail(props.value));

  return (
    <FormGroup
      style={{ marginBottom: "1rem" }}
      key={"form" + props.field}
      controlId={props.field}
    >
      {props.title && (
        <Label>
          {props.isRequired ? props.title + "*" : props.title}
        </Label>
      )}
      <Input
        style={{ fontSize: "var(--theme-font-size)" }}
        key={props.field}
        required={props.isRequired}
        type="email"
        placeholder={props.placeholder}
        value={props.value ?? ""}
        onChange={(e) => {
          props.handleChange(props.field, e.target.value);
        }}
        onBlur={() => setTouched(true)}
        disabled={props.isReadOnly}
        invalid={showError}
      />
      <FormFeedback type="invalid">
        {props.isRequired && !props.value && i18next.t("required field")}
        {props.value && !isValidEmail(props.value) && i18next.t("enter a valid email address")}
      </FormFeedback>
    </FormGroup>
  );
};

export default Email;
